<p>product-subtotal-cell works!</p>
